import { orderTotal, transactionsTotal } from "@/utils/guestOrderTotal";
import { ORDER_STATUSES, getStatusColors } from "@/utils/guestOrderStatus";

export default {
  data() {
    return {
      orderStatuses: ORDER_STATUSES,
      prepTimeDialogOpen: false,
      prepTimeTarget: null,
    };
  },
  methods: {
    // Accepting an order asks for a prep time first, same as on the kitchen
    // display board - either "ready immediately" or "ready in X minutes".
    // Every other status change goes straight through.
    requestStatusChange(order, guest, newStatus) {
      if (newStatus === "accepted") {
        this.prepTimeTarget = { order, guest };
        this.prepTimeDialogOpen = true;
        return;
      }
      this.$emit("change-status", { order, guest, newStatus });
    },
    confirmPrepMinutes() {
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "accepted",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    confirmReadyNow() {
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "ready",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    isAsapOrder(order) {
      return !!(order && order.delivery_type === 0 && !order.delivery_time);
    },
    formatOrderTime(order) {
      if (!order) return "";
      if (order.delivery_time) {
        return order.delivery_time.substring(0, 5);
      }
      if (this.isAsapOrder(order) && order.created_at) {
        return new Date(order.created_at).toLocaleTimeString("sr-Latn", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return "";
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
    statusChipStyle(status) {
      const colors = this.getStatusColors(status);
      return { backgroundColor: colors.bg, color: colors.fg };
    },
    statusDotStyle(status) {
      return { backgroundColor: this.getStatusColors(status).fg };
    },
    orderSubtotal(order) {
      if (!order || !order.order_guest_transactions) return 0;
      return transactionsTotal(order.order_guest_transactions);
    },
    calculateTotal(item) {
      if (!item.orders_guest || !item.orders_guest.length) return 0;

      return item.orders_guest.reduce((total, order) => total + orderTotal(order), 0);
    },
  },
};
